<template>
  <b-container class="custom-container px-0 py-5 mb-5">
    <div class="page-title pt-5">Create a Job</div>
    <b-card class="mt-4">
      <div class="mx-auto p-5 w-75">
        <div class="font-weight-bold mb-4 page-subtitle">Job Details</div>
        <job-form />
      </div>
    </b-card>
  </b-container>
</template>

<script>
import JobForm from '@/components/forms/JobForm'
import { mapMutations } from 'vuex'

export default {
  components: {
    JobForm
  },

  methods: {
    ...mapMutations({
      clearJobDetails: 'job/clearJobDetails'
    })
  },

  created() {
    this.clearJobDetails()
  }
}
</script>
